import type { BubbleHelp } from "../../@types/mapviewxs";

export const KEY_SHOW_HELP_TOOLTIP = "showHelpTooltip";

export interface Input {
  help?: BubbleHelp;
  overrideOpen?: boolean;
}

export interface State {
  opened: boolean;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      opened: false,
    };
  }

  onCollapse() {
    this.state.opened = false;
  }

  onExpand() {
    this.state.opened = true;
  }

  onInput(input: Input) {
    this.showTooltipOnce(input.help, input.overrideOpen);
  }

  onMount() {
    this.showTooltipOnce(this.input.help);
  }

  showTooltipOnce(model: BubbleHelp | undefined, overrideOpen?: boolean) {
    if (!model || typeof window === "undefined") return;

    if (typeof overrideOpen !== "undefined") {
      this.state.opened = overrideOpen;
      return;
    }

    const shouldOpen = window.localStorage.getItem(KEY_SHOW_HELP_TOOLTIP);
    if (shouldOpen !== "false") {
      this.state.opened = true;
    }
  }
}
